import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="color-picker"
//
// Replaces jquery.minicolors with native HTML5 <input type="color">
//
// Usage:
//   = f.input_field :header_background_color,
//       type: :color,
//       class: "form-control",
//       data: {
//         controller: "color-picker",
//         color_picker_target_value: "#report_header_123",
//         color_picker_attribute_value: "background-color",
//         action: "change->color-picker#updatePreview"
//       }
//
// Values:
//   - target: CSS selector for element to update (optional)
//   - attribute: CSS property to update (e.g., "background-color", "color")
//
export default class extends Controller {
  static values = {
    target: String,    // CSS selector for preview element (e.g., "#report_header_123")
    attribute: String  // CSS property to update (e.g., "background-color", "color")
  }

  connect() {
    // Initialize with current value if preview target exists
    if (this.hasTargetValue && this.hasAttributeValue) {
      this.updatePreview()
    }
  }

  // Called when color input changes (on change event after picker closes)
  // Also called on connect() to initialize preview with current value
  updatePreview(event) {
    const color = this.element.value

    // Update the target element's CSS if target and attribute are specified
    if (this.hasTargetValue && this.hasAttributeValue) {
      const targetElement = document.querySelector(this.targetValue)

      if (targetElement) {
        // Use setProperty() to support kebab-case CSS properties like "background-color"
        // (element.style['background-color'] doesn't work in JavaScript)
        targetElement.style.setProperty(this.attributeValue, color)
      }
    }
  }
}
